import { BasePage } from '@/components/ui/base-page'

export function CheckaCVPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add CheckaCVPage specific content here */}
    </BasePage>
  )
}